export default __webpack_public_path__ + "static/everywhere-lab-visit-5-d1ef2f5b7a5863382eed54b29e968a6a.jpg";